import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import { Breadcrumb } from 'xland-ui';
import SectionHeader from 'components/SectionHeader';
import StartupCaptableDate from 'components/StartupCaptableDate/components';
import useCaptableBreadcrumb from 'routes/Captable/hook/useCaptableBreadcrumb';
import { ROUTE_STARTUP_PATH } from 'routes';
import { useLocation, useSearchParams } from 'react-router-dom';
import { initializeCaptable } from 'routes/Captable/modules/actions';
import { AmplitudeApi } from 'utils/amplitude';
import WaterfallTab from './WaterfallTab';
import SimulationsTab from './SimulationsTab';
import OperationsTab from './OperationsTab';
import './styles.scss';

function CaptableOperations(props) {
  const {
    literalsCommon,
    literals,
    match,
    captable,
    fetchCaptable,
    startup,
  } = props;

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const captableId = searchParams.get('captable') || null;

  const { CAP_TABLE_OPERATIONS } = ROUTE_STARTUP_PATH;
  const { routes, nextRoutes } = useCaptableBreadcrumb(CAP_TABLE_OPERATIONS, startup.id, captableId);

  useEffect(() => {
    initializeCaptable(fetchCaptable, captable, match.params.id, captableId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (captable?.selected?.id) {
      AmplitudeApi.logEvent('startup.transactions.main.view', {
        captable: captable?.selected?.id,
      });
    }
  }, [captable?.selected?.id]);

  const operationsTab = [
    { key: 'operations', name: literals.operations },
    { key: 'simulations', name: literals.simulations },
    { key: 'waterfalls', name: literals.waterfall },
  ];

  if (!captable.loaded) {
    return <Loading mode='tool' />;
  }

  return (
    <>
      <Breadcrumb routes={routes} nextRoutes={nextRoutes} />
      <StartupCaptableDate startup={startup} captable={captable} noDate />
      <SectionHeader tabs={operationsTab}>
        {tab => (
          <>
            {tab === 'operations' && (
              <OperationsTab {...props} />
            )}
            {tab === 'waterfalls' && (
              <WaterfallTab
                literals={literals}
                literalsCommon={literalsCommon}
                captable={captable}
                match={match}
                fetchCaptable={fetchCaptable}
                startup={startup}
              />
            )}
            {tab === 'simulations' && (
              <SimulationsTab
                literals={literals}
                literalsCommon={literalsCommon}
                captable={captable}
                startup={startup}
                fetchCaptable={fetchCaptable}
              />
            )}
          </>
        )}
      </SectionHeader>
    </>
  );
}

CaptableOperations.propTypes = {
  literalsCommon: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  captable: PropTypes.object.isRequired,
  startup: PropTypes.object.isRequired,
  fetchCaptable: PropTypes.func.isRequired,
  editOperationTimeline: PropTypes.func.isRequired,
  editOperationDraft: PropTypes.func.isRequired,
  deleteOperation: PropTypes.func.isRequired,
};

export default CaptableOperations;
